<template>
    <div>
        <transition
            enter-active-class="transition ease-out duration-300 transform"
            enter-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="transition ease-out duration-300 transform"
            leave-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <div
                v-show="global.submission_errors.show"
                class="flex grow items-center justify-center top-0 left-0 h-screen z-50 bg-deep-blue text-center -mt-12"
                :class="[global.submission_errors.show ? 'mt-0 absolute w-full' : '']"
            >
                <div class="px-8">
                    <lottie-animation :width="180" :height="180" :path="global.app.path + 'animations/error_animation.json'" />
                    <h2 class="text-xl font-semibold mb-5">An error occurred</h2>
                    <p>
                        We are having issues processing your information.
                        <span v-if="!global.submission_errors.isServerError">
                            Please check the sections highlighted below.
                        </span>
                        <span v-else>
                            If the problem continues, please get in touch.<br />
                            <a @click="showHideSubmissionErrorsModal({show: false, isServerError: false})" class="mt-3 inline-block">Go Back</a>
                        </span>
                    </p>
                    <div v-if="!global.submission_errors.isServerError">
                        <router-link
                            v-for="(step, index) in stepper.steps"
                            :key="step.label"
                            :to="{ name: 'create-account', params: { step: index + 1 } }"
                            class="button icon-arrow-right text-white !text-left !bg-transparent !p-0 !py-2"
                            @click.native="showHideSubmissionErrorsModal({...global.submission_errors, show: false })"
                        >
                            <div class="stepper-wrapper__small mr-2 inline-block">
                                <div class="step" :class="[step.status ? step.status : '']">
                                    <div class="step-circle"></div>
                                </div>
                            </div>
                            {{ step.label }}
                        </router-link>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
    name: "SubmissionErrorsModalComponent",
    props: {},
    data: function () {
        return {};
    },
    computed: {
        ...mapGetters(["global", "stepper"]),
    },
    methods: {
        ...mapActions(["showHideSubmissionErrorsModal"]),
    },
};
</script>
